import { Link } from 'react-router-dom'
import { InvoiceStatusBadge } from '@/components/InvoiceStatusBadge'
import { formatCustomerNumber } from '@/lib/customer'
import { formatCurrency, formatDate } from '@/lib/format'
import type { Invoice } from '@/api/types'

const UNNUMBERED_LABEL = 'planerad'
const EMPTY_VALUE = '–'
const UNKNOWN_CUSTOMER_LABEL = 'Okänd kund'

function formatOptionalDate(value: string | null): string {
  if (value === null) {
    return EMPTY_VALUE
  }

  return formatDate(value)
}

export function InvoiceTableRow({ invoice }: { invoice: Invoice }): React.ReactElement {
  const customerName = invoice.customer_name ?? UNKNOWN_CUSTOMER_LABEL
  const invoiceNumber = invoice.invoice_number ?? UNNUMBERED_LABEL
  const amount = formatCurrency(Number(invoice.amount))
  const remaining = formatCurrency(Number(invoice.remaining_sum))

  return (
    <tr className="border-t border-border/70">
      <td className="px-6 py-4 font-medium">
        <Link
          to={`/invoices/${invoice.id}`}
          className="hover:underline"
        >
          {customerName}
        </Link>
        <span className="mt-1 block text-xs font-normal text-muted-foreground">{formatCustomerNumber(invoice.customer_id)}</span>
      </td>
      <td className="px-6 py-4">
        <Link
          to={`/invoices/${invoice.id}`}
          className="hover:underline"
        >
          {invoiceNumber}
        </Link>
      </td>
      <td className="px-6 py-4 text-muted-foreground">{formatOptionalDate(invoice.invoice_date)}</td>
      <td className="px-6 py-4 text-muted-foreground">{formatOptionalDate(invoice.due_date)}</td>
      <td className="px-6 py-4 text-right tabular-nums">{amount}</td>
      <td className="px-6 py-4 text-right tabular-nums">{remaining}</td>
      <td className="px-6 py-4">
        <InvoiceStatusBadge status={invoice.status} />
      </td>
    </tr>
  )
}
